import { useEffect, useState } from 'react';

import cn from 'classnames';
import { MESSAGE_STATE_ERROR } from 'constants/message-app-state-contants';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { List } from 'components/List/List';

import {
  addBrandUpload,
  createBrand,
  deleteBrand,
  getBrandUploads,
  getBrands,
  removeBrandUpload,
  selectBrands,
  updateBrand,
} from 'api/brands-slice';

import { BrandingEdit } from './BrandingEdit/BrandingEdit';

export const Branding = ({ user, messagePopUp = () => {}, setLoading = () => {} }) => {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const brands = useSelector(selectBrands);

  const brandIdParam = searchParams.get('brandId');

  const onGetBrands = () => dispatch(getBrands());
  const onCreateBrand = name => dispatch(createBrand(name));
  const onBrandUpdate = (id, data) => dispatch(updateBrand({ id, data }));
  const onDeleteBrand = id => dispatch(deleteBrand(id));
  const onGetBrandUploads = id => dispatch(getBrandUploads(id));
  const onRemoveBrandUpload = (brandId, uploadId) =>
    dispatch(removeBrandUpload({ brandId, uploadId }));
  const onAddBrandUpload = (brandId, upload) => dispatch(addBrandUpload({ brandId, upload }));

  const [brandId, setBrandId] = useState();

  useEffect(() => {
    setLoading(true);
    onGetBrands().then(_ => setLoading(false));
  }, []);

  useEffect(() => {
    if (brandIdParam) {
      setBrandId(parseInt(brandIdParam));
    }
  }, [brandIdParam]);

  const createNewBrand = async () => {
    setLoading(true);
    const { payload: newBrand } = await onCreateBrand('New Brand');
    setBrandId(newBrand.id);
    setLoading(false);
  };

  const handleUpdate = async data => {
    setLoading(true);
    const brand = brands.find(brand => brand.id === brandId);
    const signatureUpdated =
      data.brand_email &&
      (brand.brand_email !== data.brand_email || brand.brand_name !== data.brand_name);
    data = { ...data, signature_updated: signatureUpdated };
    const { payload: response } = await onBrandUpdate(brand.id, data);

    if (response.error) messagePopUp(response.error.message, MESSAGE_STATE_ERROR);
    setLoading(false);
  };

  const handleDelete = async id => {
    setLoading(true);
    setBrandId(null);
    await onDeleteBrand(id);
    setLoading(false);
  };

  const onChangeDefault = async id => {
    setLoading(true);
    const { payload: response } = await onBrandUpdate(id, { default: true });
    if (response.error) messagePopUp(response.error.message, MESSAGE_STATE_ERROR);

    setBrands(
      brands.map(brand => {
        brand.default = brand.id === id;
        return brand;
      }),
    );
    setLoading(false);
  };

  return (
    <div className={cn('u-flex-box', 'u-flex-align-start')}>
      <List
        title="Branding"
        subtitle="Create and manage your companies branding, which is used when interacting with candidates and references via Checkmate."
        className="u-margin-right--large u-flex-align-self-normal"
        onNew={createNewBrand}>
        <List.Category title="Brands">
          {brands.map(brand => (
            <List.Item key={brand.id} title={brand.name} value={brand.id} onClick={setBrandId} />
          ))}
        </List.Category>
      </List>
      {brandId && (
        <BrandingEdit
          user={user}
          brand={brands.find(brand => brand.id === brandId)}
          onClose={() => setBrandId(null)}
          setLoading={setLoading}
          messagePopUp={messagePopUp}
          updateBrand={handleUpdate}
          changeDefault={onChangeDefault}
          getBrandUploads={onGetBrandUploads}
          removeBrandUpload={onRemoveBrandUpload}
          addBrandUpload={onAddBrandUpload}
          onDelete={handleDelete}
        />
      )}
    </div>
  );
};
